<template>
    <div class="wrap" @click="removeOverlay">
        <div class="wrap_inner">
            <div class="wrap_main">
                <div class='mainlist' :style="{position:absolute,top:0,bottom:0,overflow:disShow?'hidden':'auto'}">
                    <div class="blk1s" style="position:relative;background:#fff;">
                        <img src="./image/home-banner2.png" style="position:absolute;top:0;left:0;width: 100%;height: 100%"></img>
                        <!-- <div class="blkps">
					   <div class="blkrect"></div>
					   <div class="txtku1">首页</div>
					   <div class="txtku2">{{companyName}}</div>
				   </div> -->
                    </div>
                    <div class="myStyu">
                        <div class="notice" v-if="noticeList.length>0">
                            <div style="position:absolute;top:0;left:0;width:100%"><img src="./image/notice.png" class="img1"></img></div>
                            <van-swipe @change="onChange" :show-indicators="show" vertical :autoplay="3000" style="width:100%">
                                <van-swipe-item style="width:100%" v-for="(item,index) in noticeList" :key="index">
                                    <div class="nDiv" style="width:100%" @click="toNotice">
                                        <div class="txt1">{{item.noticeTitle}}</div>
                                    </div>
                                </van-swipe-item>
                            </van-swipe>
                        </div>
                        <div v-else class="notice">
                            <div class="nDiv" style="width:100%" @click="toNotice">
                                <div><img src="./image/speaker@2x.gif" class="img1" /></div>
                                <div class="txt1">暂无公告</div>
                                <div><img src="./image/back@2x.png" class="img2" /></div>
                            </div>
                        </div>
                    </div>
                    <div class="xzSty">
                        <div class="xzSty1" @click="tDetail(1)">
                            <img src="./image/ksbx.png" style="width:100%;height:100%">
                        </div>
                        <div class="xzSty2">
                            <div class="yjSty" @click="tDetail(3)"><img src="./image/rjbx.png" style="width:100%;height:100%"></div>
                            <div class="yjSty" @click="tDetail(2)"><img src="./image/yjbx.png" style="width:100%;height:100%"></div>
                        </div>
                    </div>
                    <div>
                        <van-tabs @click="onClick" align="left">
                            <van-tab>
                                <template #title>
                                    <div class="iTit1">响应支持</div>
                                    <div class="iTit2">
                                        <div class="iTit21">{{xyCount}}</div>
                                    </div>
                                </template>
                                <div class="engSty1">
                                    <!-- <van-collapse v-model="activeName" accordion>
						  	  <van-collapse-item title="响应支持" name="1"> -->
                                    <div v-if="datas.length>0">
                                        <div ref="wrap" class="scroll_wrap" style="background: #f4f7f9;">
                                            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                                                <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false" :error.sync="error" error-text="请求失败，点击重新加载">
                                                    <!-- 列表区域 -->
                                                    <!-- <div  v-for="(item,index) in datas" :key="index" class="cWrap">
						  						    <PJXQ :item="item" :datas="datas" @close="getClose" @fatherMethod="fatherMethod"></PJXQ>
						  						</div> -->
                                                    <PJXQ :key="random" :datas="datas" :currentb="currentb" @close="getClose" @fatherMethod="fatherMethod"></PJXQ>
                                                </van-list>
                                            </van-pull-refresh>
                                        </div>
                                    </div>
                                    <div v-else class="nData">暂无数据</div>
                                    <!-- </van-collapse> -->
                                </div>
                            </van-tab>
                        </van-tabs>
                    </div>
                    <!-- <div v-if="disShow" style="width:100%;height:100%;z-index:3000">
                        <div ref="dig" class="mtblks" style="position:absolute;top:0;left:0;width:100%;height:100%;z-index:1000;opacity: 0.95;background: #333333;">
                            <div class="dialogs1">
                                <div class="digtxt">确认关闭响应支持吗</div>
                                <div class="txtx" @click="reback"><img src="./image/x@2x.png" style="position:absolute;top:0;right:0;width:100%;height:100%"></img></div>
                                <div class="c" style="display:flex;align-items:center;justify-content:center">
                                    <div class="reback" @click="reback">返回</div>
                                    <div class="submit" @click="submit1">确定</div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <customToast :toastRow="toastRow" :show="toastFlag"></customToast>
                    <van-dialog v-model:show="disShow" @cancel="reback" @confirm="submit1" confirm-button-color="#108EE9" show-cancel-button>
                        <div class="digtxt3">
                            <img src="../../components/image/error.png" alt="" style="width: 35%;padding-top: 25px;">
                            <div style="padding: 20px 0;">确认关闭响应支持</div>
                            <!-- <van-field v-model="reasons" style="border:1px solid #eee" rows="3" autosize type="textarea" placeholder="请输入关闭原因" /> -->
                        </div>
                    </van-dialog>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import customToast from "@/components/toast.vue";
import PJXQ from "@/components/pjxq.vue";
export default {
    name: "pjxq",
    components: {
        PJXQ,
        customToast,
    },
    data() {
        return {
            toastFlag: false,
            toastRow: {},
            xyCount: 0,
            random: Math.random() * 100,
            current: null,
            error: false,
            loading: false,
            finished: false,
            refreshing: false,
            qureyFrom: {
                pageNum: 1,
                pageSize: 50,
            },
            disShow: false,
            recordId1: "",
            activeName: "1",
            companyName: "",
            datas: [],
            userInfo: [],
            bool: false,
            show: false,
            noticeList: [
                {
                    id: 1,
                    value: "暂无公告",
                },
            ],
            failItem: [],
        };
    },
    created() {
        this.getEngData();
        this.getNotice();
        this.getlevelData();
        // console.log(this.$store.state.user.userInfo)
        this.companyName = this.$store.state.user.userInfo.companyName;
    },
    methods: {
        fatherMethod(val) {
            this.currentb = val;
        },
        removeOverlay() {
            this.currentb = null;
            this.random = Math.random() * 100;
        },
        tDetail(id) {
            if (id == 2) {
                this.$router.push({ path: "/yjProperty" });
            } else if (id == 3) {
                this.$router.push({ path: "/rjProperty" });
            } else if (id == 1) {
                this.$router.push({ path: "/qtpropertyDetail" });
            }
        },
        //请求失败
        requestErr() {
            this.loading = false;
            this.refreshing = false;
            this.error = true;
        },
        // 上拉刷新
        onRefresh() {
            this.finished = false;
            this.loading = true;
            this.qureyFrom.pageNum = 1;
            this.datas = [];
            this.getData();
        },
        reback() {
            this.disShow = false;
        },
        submit1() {
            let data = { recordId: this.recordId1 };
            this.$api
                .get("/app/support/deleteSupport", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        // this.$toasts("关闭成功");
                        this.toastRow = {
                            selId: 3,
                            title: "成功关闭",
                            text: "您已成功关闭响应支持",
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                        this.error = false;
                        this.loading = false;
                        this.finished = false;
                        this.refreshing = false;
                        this.qureyFrom = {
                            pageNum: 1,
                            pageSize: 50,
                        };
                        this.datas = [];
                        this.disShow = false;
                        this.getData();
                    }
                });
        },
        getClose(data1, data2) {
            this.disShow = data1 == 1 ? true : false;
            this.recordId1 = data2;
        },
        getlevelData() {
            let data = {
                dictType: 1,
                companyId: this.$store.state.user.userInfo.companyId,
            };
            this.$api
                .get("/appConfigDictData/selectConfig", { params: data })
                .then((res) => {
                    if (res.data.code == "0000") {
                        this.failItem = res.data.data;
                        this.getData();
                    } else if (res.data.code == "9999") {
                        // this.$toast(res.data.message);
                        this.toastRow = {
                            selId: 4,
                            title: res.data.message,
                            text: res.data.message,
                        };
                        this.toastFlag = true;
                        setTimeout(() => {
                            this.toastFlag = false;
                        }, 1500);
                    }
                });
        },
        onChange(index) {},
        ptConsult() {
            this.$router.push({ path: "/consult" });
        },

        getData() {
            this.finished = false;
            let userId = this.$store.state.user.userInfo.userId;
            let role = this.$store.state.user.userInfo.role;
            if (role == 1) {
                let data = {
                    companyId: this.$store.state.user.userInfo.companyId,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
                this.$api
                    .post("/app/support/getSupportRecordListByUserId", data)
                    .then((res) => {
                        if (res.data.code == "0000") {
                            this.xyCount = res.data.data.count;
                            this.qureyFrom.pageNum++;
                            if (this.refreshing) {
                                this.data = [];
                                this.refreshing = false;
                            }
                            const { datalist, count } = res.data.data;
                            this.datas = this.datas.concat(datalist);
                            this.datas.forEach((item) => {
                                item.tShow = 0;
                            });
                            this.loading = false;
                            if (this.datas.length >= count) {
                                this.finished = true; //已全部请求完毕
                            }
                        } else {
                            this.datas = [];
                            this.requestErr();
                        }
                    })
                    .catch((err) => {
                        this.requestErr();
                    });
            } else {
                let data = {
                    userId: userId,
                    pageNum: this.qureyFrom.pageNum,
                    pageSize: this.qureyFrom.pageSize,
                };
                this.$api
                    .post("/app/support/getSupportRecordListByUserId", data)
                    .then((res) => {
                        if (res.data.code == "0000") {
                            this.xyCount = res.data.data.count;
                            this.qureyFrom.pageNum++;
                            if (this.refreshing) {
                                this.data = [];
                                this.refreshing = false;
                            }
                            const { datalist, count } = res.data.data;
                            this.datas = this.datas.concat(datalist);
                            this.loading = false;
                            if (this.datas.length >= count) {
                                this.finished = true; //已全部请求完毕
                            }
                        } else {
                            this.datas = [];
                            this.requestErr();
                        }
                    })
                    .catch((err) => {
                        this.requestErr();
                    });
            }
        },
        getNotice() {
            let data = { noticeType: 1, noticeStatus: 0 };
            this.$api.post("/app/notice/getNotice", data).then((res) => {
                if (res.data.code == "0000") {
                    if (res.data.data) {
                        let data = res.data.data.datalist;
                        this.noticeList = data;
                    }
                } else {
                    this.noticeList = [];
                }
            });
        },
        getEngData() {
            let companyId = this.$store.state.user.userInfo.companyId;
            let data = { pointCompanyId: companyId };
            this.$api.post("/app/user/getEngineerInfo", data).then((res) => {
                if (res.data.code == "0000") {
                    let data = res.data.data.datalist;
                    data.forEach((item) => {
                        if (item.headImg) {
                            // item.headImg="http://106.15.237.145:9095/prod-yh"+item.headImg
                            item.headImg =
                                process.env.VUE_APP_IMG_URL + item.headImg;
                            // item.headImg='http://180.100.77.186:9085/prod-yh'+item.headImg
                        }
                    });
                    this.userInfo = data;
                } else {
                    this.userInfo = [];
                }
            });
        },
        ptProperty() {
            this.$router.push({ path: "/ryProperty" });
        },
        ptCapital() {
            this.$router.push({ path: "/ryCapital" });
        },
        toInfo(id) {
            this.$router.push({ path: "/myInfo", query: { engineerId: id } });
        },
        ptComplaint() {
            this.$router.push("/complaint");
        },
        toNotice() {
            this.$router.push("/noticeList");
        },
        ptExchange() {
            // this.$router.push('/exchange')
            this.$toast("待上线，尽请期待...");
        },
    },
};
</script>

<style scoped>
::v-deep .van-dialog {
    width: 75% !important;
}
::v-deep .van-field__value {
    overflow: auto;
}
::v-deep .van-field {
    max-height: 200px;
    height: auto !important;
}
.digtxt3 {
    width: 80%;
    margin: 0 auto;
    padding: 20px 0;
    /* margin-bottom: 54px; */
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.wrap {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.iTit1 {
    flex: 1;
    display: flex;
    align-items: center;
    border-bottom: 3px solid #0080ff;
}
.iTit2 {
    /* flex:1; */
    font-size: 10px;
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
}
.iTit21 {
    width: auto;
    height: 18px;
    line-height: 14px;
    min-width: 18px;
    padding: 2px 2px;
    text-align: center;
    box-sizing: border-box;
    color: #ffffff;
    background: #ff0000;
    border-radius: 50%;
}
/deep/ .van-tab__text--ellipsis {
    display: flex;
    height: 100%;
}
/deep/ .van-tab {
    flex: 0 0 125px;
    margin-left: 20px;
    /* text-align:center; */
    justify-content: flex-start;
    /* justify-content: flex-start; */
    /* border-bottom:1px solid #ccc; */
}
/deep/ .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #ccc;
}
/deep/ .van-tabs__line {
    background-color: transparent;
    text-align: left;
}

/deep/ .van-tab__text--ellipsis {
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #0080ff;
}
.yjSty {
    display: flex;
    width: 100%;
    height: 70px;
}
.yjSty:nth-child(1) {
    margin-top: 5.5px;
}
.yjSty:nth-child(2) {
    margin-top: 7px;
}
.xzSty {
    display: flex;
    width: 100%;
    height: 164px;
    padding: 0 20px 0 11px;
    box-sizing: border-box;
    margin-top: 8px;
}
.xzSty1 {
    display: flex;
    flex: 0 0 184px;
    width: 184px;
    height: 164px;
}
.xzSty2 {
    display: flex;
    flex-direction: column;
    flex: 0 0 160px;
    width: 160px;
    height: 164px;
}
.nData {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
}
.nDiv {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
/*    .wrap{
        position: absolute;
            top: 0;
            left:0;
            width:100%;
            height:100%;
            overflow: auto;
			overflow-x:hidden;
            background:#e9eef2;
    }
    .wrap_inner{
         min-height: 100%;
         width:100%;
    }
    .wrap_main{
        padding-bottom: 70px;
    }
	.mainlist{
	    width:100%;
	    height:100%;
	} */
.tgSty {
    width: 100%;
    height: 113px;
    background: #fff;
    padding: 0;
    box-sizing: border-box;
}
.wrap {
    position: absolute;
    top: 0;
    left: 0;
    /* z-index:1000; */
    width: 100%;
    height: 100%;
    overflow: auto;
    background: #fff;
    overflow-x: hidden;
}
.wrap_inner {
    min-height: 100%;
    width: 100%;
}
.wrap_main {
    position: absolute;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 50px;
}
.cWrap {
    /* height:152px; */
}
.myStyu {
    width: 100%;
    height: 36px;
    padding: 0 20px;
    box-sizing: border-box;
}
.mainlist {
    width: 100%;
    height: 100%;
}
.sImg {
    width: 100%;
    height: 148px;
}
.i_title {
    width: 335px;
    height: 20px;
    padding: 0 12px;
    margin: 0 auto;
    /* margin-left:10px; */
    font-size: 16px;
    font-weight: 700;
    text-align: left;
    color: #333333;
    /* margin-left:18px; */
}
.ghtSty {
    width: 100%;
    height: 40px;
    background: #fff;
    margin-top: 8px;
    padding: 10px 0;
    box-sizing: border-box;
}
.engStym {
    position: relative;
    display: flex;
    align-items: center;
    padding: 9px 12px;
    height: 62px;
    width: 309px;
    margin: 11px auto;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    font-size: 12px;
}
.engSty {
    position: relative;
    display: flex;
    align-items: center;
    padding: 9px 12px;
    height: 62px;
    width: 309px;
    margin: 20px auto;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    font-size: 12px;
}
.engSty1 {
    height: 100%;
    width: 100%;
    margin: 0px auto;
    border-radius: 4px;
    font-size: 12px;
}
.engSty6 {
    height: 88px;
    width: 335px;
    margin: 0px auto;
    border-radius: 4px;
    font-size: 12px;
    padding: 20px 0 0 0;
}
.engSty1 /deep/ .van-collapse-item:nth-child(1) .van-cell {
    background: #e3f7fb;
}
.engSty1 /deep/ .van-collapse-item:nth-child(2) .van-cell {
    background: #fbfadd;
}
.engSty1 /deep/ .van-collapse-item:nth-child(1) .van-collapse-item__content {
    background: #d5e6e9;
}
.engSty1 /deep/ .van-collapse-item:nth-child(2) .van-collapse-item__content {
    background: #e5e5d0;
}
.engSty > div {
    flex: 1;
}
.engSty > div:nth-child(1) {
    flex: 0 0 44px;
}
.engSty > div:nth-child(3) {
    flex: 0 0 10px;
}
.gRects {
    position: absolute;
    bottom: 15px;
    left: 44px;
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background: #09f175;
}
.tButs {
    width: 335px;
    height: 93px;
    overflow: hidden;
    margin: 20px auto;
    background: #ffffff;
}
.tBut {
    width: 335px;
    height: 93px;
    padding: 0px 20px;
    border-radius: 4px;
    box-shadow: 0px 3px 6px 0px rgba(16, 82, 139, 0.16);
    box-sizing: border-box;
    font-size: 12px;
    overflow-x: auto;
    display: flex;
    flex-direction: row;
}
.tBut > div {
    flex: 0 0 25%;
}
.tCell {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.mCell {
}
.tjSty {
    width: 156px;
    height: 33px;
    line-height: 33px;
    opacity: 1;
    text-align: left;
    font-size: 24px;
    font-weight: 800;
    color: #ffffff;
}
.notice {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
    font-size: 12px;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
/deep/ .van-swipe__track--vertical {
    height: 35px !important;
}
/deep/ .van-swipe__track--vertical {
    width: 100%;
    height: 35px !important;
}
.img1 {
    width: 100%;
    height: 36px;
}
.txt1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 0 20px 0 47px;
    box-sizing: border-box;
    line-height: 36px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    color: #333333;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.img2 {
    width: 22px;
    height: 22px;
}
.fpSty {
    width: 156px;
    height: 33px;
    line-height: 33px;
    opacity: 1;
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
}
.imgkl {
    width: 22px;
    height: 22px;
}
.imgp {
    width: 10px;
    height: 14px;
    color: #fff;
    font-size: 20px;
}
.img3 {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
}
.img4 {
    width: 44px;
    height: 44px;
    margin-bottom: 10px;
    margin-top: 10px;
}
.blk1 {
    display: flex;
    flex-direction: column;
    margin-left: 20px;
}
.txtn {
    width: 200px;
    height: 20px;
    overflow: hidden;
    　　text-overflow: ellipsis;
    　　white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    margin-bottom: 4px;
}
.blk1s {
    position: relative;
    width: 353px;
    height: 166px;
    margin: 0 auto;
    border-radius: 18px;
    margin-top: 10px;
}
.mySty {
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 44px;
    width: 156px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 0 0 0;
}
.blkps {
    position: absolute;
    top: 35px;
    right: 0px;
    width: 162px;
    height: 90px;
}
.blkrect {
    width: 20px;
    height: 2px;
    background: #ffffff;
}
.txtku1 {
    margin: 4px 0 10px 0;
    font-size: 20px;
    font-weight: 800;
    text-align: left;
    color: #ffffff;
}
.txtku2 {
    position: absolute;
    bottom: 5px;
    right: 10px;
    width: 152px;
    height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
}
.dialogs1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 285px;
    height: 189px;
    background: #fff;
    border-radius: 8px;
    z-index: 1000;
}
.digtxt {
    width: 200px;
    height: 28px;
    margin: 34px auto;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.digtxt1 {
    width: 200px;
    height: 28px;
    margin: 24px auto;
    margin-bottom: 54px;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
    color: #003cff;
    line-height: 33px;
}
.txtx {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    flex: 1;
}
.reback {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #ffffff;
    border: 2px solid #0080ff;
    border-radius: 23px;
    color: #0080ff;
    font-size: 18px;
}
.submit {
    flex: 0 0 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: linear-gradient(140deg, #36b3fe 4%, #0080ff 96%);
    border-radius: 23px;
    color: #fff;
    font-size: 18px;
    margin-left: 20px;
}
.yuSty {
    width: 100%;
    background: #fff;
    margin-top: 8px;
    padding: 3px 0;
    box-sizing: border-box;
}
</style>